// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"210":"b860675a","242":"c4821db1","453":"d78093b3","482":"be5195f6"}[chunkId] + ".chunk.js";
};